










import Vue from 'vue'

import AttachmentsList from './AttachmentsList.vue'
import { FileAttachment } from './file-attachment.interface'

export default Vue.extend({
  components: {
    AttachmentsList
  },
  data() {
    return {
      acceptedAttachmentFileTypes: '.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,image/*,text/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      attachments: [] as FileAttachment[]
    }
  },
  methods: {
    removeAllAttachments() {
      this.attachments = []
    },
    openFileUpload() {
      (this.$refs.fileInput as HTMLElement).click()
    },
    addFiles() {
      const files = (this.$refs.fileInput as HTMLInputElement).files
      if (!files) return

      this.addFilesFromFileList(files)
    },
    addFileFromDrop(event: DragEvent) {
      if (!event.dataTransfer) return

      this.addFilesFromFileList(event.dataTransfer.files)
    },
    addFilesFromFileList(files: FileList) {
      for (let index = 0; index < files.length; index++) {
        const file = files[index]
        this.attachments.push({ id: -1, author_id: -1, file_reference_id: -1, title: file.name, file })
      }
    }
  }
})
